export default __webpack_public_path__ + "static/media/arrow.18ea1153.svg";